const jsonLogic = require('json-logic-js');

// Add custom JSONLogic string operators for keyword routing
jsonLogic.add_operation('contains', (haystack: string, needle: string) => {
    return typeof haystack === 'string' && typeof needle === 'string' ? haystack.includes(needle) : false;
});

jsonLogic.add_operation('starts_with', (str: string, prefix: string) => {
    return typeof str === 'string' && typeof prefix === 'string' ? str.startsWith(prefix) : false;
});

jsonLogic.add_operation('equal_ignore_case', (str1: string, str2: string) => {
    if (typeof str1 === 'string' && typeof str2 === 'string') {
        return str1.toLowerCase() === str2.toLowerCase();
    }
    return str1 === str2;
});

jsonLogic.add_operation('contains_ignore_case', (haystack: string, needle: string) => {
    return typeof haystack === 'string' && typeof needle === 'string'
        ? haystack.toLowerCase().includes(needle.toLowerCase())
        : false;
});

jsonLogic.add_operation('starts_with_ignore_case', (str: string, prefix: string) => {
    return typeof str === 'string' && typeof prefix === 'string'
        ? str.toLowerCase().startsWith(prefix.toLowerCase())
        : false;
});

jsonLogic.add_operation('is_empty', (value: string) => {
    return value.trim() === '';
});

jsonLogic.add_operation('is_not_empty', (value: string) => {
    return value.trim() !== '';
});

jsonLogic.add_operation('is_empty_or_null', (value: string | null) => {
    return value === null || value.trim() === '';
});

jsonLogic.add_operation('is_not_empty_or_null', (value: string | null) => {
    return value !== null && value.trim() !== '';
});

/**
 * A customized jsonLogic instance with custom operators for keyword routing.
 */
export const jsonLogicInstance = jsonLogic;
